<template>
  <transition name="fade">
    <div v-if="active" class="loading-container" :style="{ width: width, height: height }">
      <div class="dots-loader" :style="{ '--dot-color': color }">
        <span></span><span></span><span></span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LoadingDots",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "100px"
    },
    height: {
      type: String,
      default: "100px"
    },
    color: {
      type: String,
      default: "#42b983"
    }
  }
};
</script>

<style scoped>
.loading-container {
  /* width: 100%; */
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0);
}

.dots-loader {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dots-loader span {
  width: 12px;
  height: 12px;
  margin: 0 5px;
  background-color: var(--dot-color, #42b983);
  border-radius: 50%;
  animation: dots 1.4s infinite ease-in-out both;
}

.dots-loader span:nth-child(1) { animation-delay: -0.32s; }
.dots-loader span:nth-child(2) { animation-delay: -0.16s; }
.dots-loader span:nth-child(3) { animation-delay: 0; }

@keyframes dots {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
